const W = 56; // inner width between ║ markers
const bar = '═'.repeat(W);
const p = (s) => `║ ${s.padEnd(W - 2)} ║`;
const blank = p('');

const DOCUMENTS = [
  {
    title: 'PROJECT DEEP MIRROR',
    classification: 'TOP SECRET // UMBRA // NOFORN',
    date: '1977-AUG-14',
    from: 'DIR. ADVANCED RESEARCH, FOLK.CODES',
    to: 'JOINT CHIEFS — TERMINAL OPS',
    body: [
      'RE: ANOMALOUS SIGNAL — SECTOR 7G',
      '',
      'AT 0347 HOURS ON ██████████, DEEP SPACE',
      'ARRAY STATION ████████ INTERCEPTED A',
      'REPEATING SIGNAL FROM COORDINATES',
      '██.████ / ██.████ / ████.██.',
      '',
      'THE SIGNAL, DESIGNATED ████████████,',
      'CONSISTS OF A ███-SECOND BURST REPEATING',
      'EVERY ██ MINUTES. SPECTRAL ANALYSIS',
      'REVEALS ██████████████████████████████',
      '██████████████████████████████████████.',
      '',
      'DR. ████████ OF THE ████████████ LAB HAS',
      'CONFIRMED THE SIGNAL IS ████████████ IN',
      'NATURE AND DOES NOT MATCH ANY KNOWN',
      '██████████ OR NATURAL ████████ SOURCE.',
      '',
      'RECOMMEND IMMEDIATE DEPLOYMENT OF',
      '████████████ TO STATION ████████.',
      '',
      '*** THIS DOCUMENT WILL SELF-DESTRUCT ***',
      '*** IN YOUR IMAGINATION ***',
    ],
  },
  {
    title: 'OPERATION CINDER MOTH',
    classification: 'SECRET // SPECIAL ACCESS REQUIRED',
    date: '1983-NOV-22',
    from: 'TERMINAL INTELLIGENCE BUREAU',
    to: 'DEPUTY DIR., FOLK.CODES DIVISION',
    body: [
      'RE: SUBJECT "MOTHMAN" — STATUS REPORT',
      '',
      'FIELD OPERATIVE ████████ REPORTS THAT',
      'SUBJECT ████████████ WAS LAST OBSERVED',
      'AT ██████████, ████████, ON THE EVENING',
      'OF ██████████.',
      '',
      'SUBJECT EXHIBITED ████████████████████',
      'BEHAVIOR CONSISTENT WITH PREVIOUS',
      'ENCOUNTERS IN FILE ████-████-████.',
      'NOTABLY, ████████████████████████████',
      '████████████████████ WHICH CONTRADICTS',
      'DR. ████████\'S ████ REPORT.',
      '',
      'LOCAL LAW ENFORCEMENT HAS BEEN',
      '████████████ AND ALL CIVILIAN WITNESSES',
      'HAVE BEEN ████████████.',
      '',
      'PHOTOGRAPHIC EVIDENCE [ATTACHMENT ████]',
      'SECURED IN VAULT ████ AT ████████████.',
      '',
      '*** EYES ONLY — DO NOT DISTRIBUTE ***',
    ],
  },
  {
    title: 'MEMORANDUM 7741-B',
    classification: 'TOP SECRET // COSMIC // ORCON',
    date: '1969-JUL-21',
    from: 'OFFICE OF TERMINAL ARCHAEOLOGY',
    to: 'ADMINISTRATOR, FOLK.CODES DIVISION',
    body: [
      'RE: ARTIFACT RECOVERY — SITE ████████',
      '',
      'EXCAVATION TEAM ████ HAS COMPLETED',
      'PHASE ██ OF THE DIG AT ██████████.',
      '██ ARTIFACTS HAVE BEEN CATALOGUED.',
      '',
      'ITEM ████-A IS OF PARTICULAR INTEREST.',
      'THE OBJECT APPEARS TO BE ████████████',
      'COMPOSED OF AN UNKNOWN ████████████',
      'ALLOY. WHEN EXPOSED TO ██████████,',
      'IT EMITS A ████████████████ FIELD',
      'MEASURABLE AT ████ ██████████.',
      '',
      'CARBON DATING PLACES THE ARTIFACT AT',
      '██,███ YEARS OLD, WHICH ██████████████',
      '████████████████████████████████████.',
      '',
      'ALL PERSONNEL WITH KNOWLEDGE OF ITEM',
      '████-A TRANSFERRED TO ████████████',
      'FACILITY UNDER PROTOCOL ████████.',
      '',
      'FURTHER ANALYSIS REQUIRES CLEARANCE',
      'LEVEL ██████.',
      '',
      '*** UNAUTHORIZED ACCESS IS A ***',
      '*** FEDERAL OFFENSE ***',
    ],
  },
  {
    title: 'INCIDENT REPORT XX-1',
    classification: 'ABOVE TOP SECRET // FOLK EYES ONLY',
    date: '████-███-██',
    from: '████████████████████████',
    to: 'THE ADMINISTRATOR',
    body: [
      'RE: THE ████████████ EVENT',
      '',
      'AT ████ HOURS, ██████████████████████',
      '██████████████████████████████████████',
      '██████████████████████████████████████.',
      '',
      '██████████████████████████████████████',
      '██████████████████████████████████████',
      '████████████████████ SEVEN PERSONNEL',
      '██████████████████████████████████████.',
      '',
      '██████████████████████████████████████',
      '██████████████████████████████████████',
      '██████████████████ WHICH IS, FRANKLY,',
      '██████████████████████████████████████.',
      '',
      'SITE HAS BEEN ████████████████ AND ALL',
      '██████████ HAVE BEEN ADMINISTERED',
      '████████████████████████.',
      '',
      'THIS DOCUMENT DOES NOT EXIST.',
      'YOU HAVE NOT READ THIS.',
      'RESUME NORMAL OPERATIONS.',
      '',
      '*** [EXPUNGED BY ORDER OF ██████] ***',
    ],
  },
];

export default function Classified() {
  const doc = DOCUMENTS[Math.floor(Math.random() * DOCUMENTS.length)];

  const lines = [
    `╔${bar}╗`,
    p(`%%%  ${doc.classification}`),
    `╠${bar}╣`,
    blank,
    p(`DOCUMENT:  ${doc.title}`),
    p(`DATE:      ${doc.date}`),
    blank,
    p(`FROM:  ${doc.from}`),
    p(`TO:    ${doc.to}`),
    blank,
    `╠${bar}╣`,
    blank,
    ...doc.body.map(l => l === '' ? blank : p(`  ${l}`)),
    blank,
    `╠${bar}╣`,
    blank,
    p('CLASSIFICATION REVIEW: ████████████'),
    p('DECLASSIFY ON: ████-██-██'),
    p('COPY ██ OF ██'),
    blank,
    `╚${bar}╝`,
  ];

  return (
    <pre className="nasa-report classified-doc">{'\n' + lines.join('\n') + '\n'}</pre>
  );
}
